import RecentActivityPage from './RecentActivityPage'
export default RecentActivityPage
